import { put, call, takeLatest, select } from "redux-saga/effects";
import * as portal from "../api/portalApi";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";

export default function* profileToolsSaga() {
    yield takeLatest(types.PATIENT_DEMOGRAPHICS_START, handlePatientDemographics);
    yield takeLatest(types.GET_PROVIDER_JWT, handleGetProviderJWT);
}

export function* handlePatientDemographics(data) {
    const start = new Date();
    try {
        if (!data || !data.externalId) {
            yield put({ type: types.PATIENT_DEMOGRAPHICS_FAILURE, error: 'Sorry, it appears the patient has no external id.' });
            logAPI("Saga.Portal.PatientPhoto.Failure", start, null);
            if (data.callback) {
                data.callback(null, error);
            }
            return;
        }

        const domain = yield select((state) => state.domain);
        const response = yield call(portal.getPatientDemographics, domain.t, data.externalId.trim(), 'External');
        if (response) {
            yield put({ type: types.PATIENT_DEMOGRAPHICS_SUCCESS, response: response });
            logAPI("Saga.Portal.PatientDemographics", start, null);
            if (data.callback) {
                data.callback(response, null);
            }
        }
        else {
            yield put({ type: types.PATIENT_PHOTO_FAILURE, error: 'No demographics found.' });
            logAPI("Saga.Portal.PatientDemographics.Failure", start, null);
            if (data.callback) {
                data.callback(null, error);
            }
        }
    }
    catch (error) {
        logAPI("Saga.Portal.PatientDemographics.Failure", start, null);
        yield all([
            put({ type: types.PATIENT_DEMOGRAPHICS_FAILURE, error }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
        if (data.callback) {
            data.callback(null, error);
        }
    }
}

//export function* handleGetRoomStatuses() {
//    const start = new Date();

//    try {
//        const domain = yield select((state) => state.domain);
//        const statuses = yield call(portal.getRoomStatuses, domain.t);
//        yield put({ type: types.GET_ROOM_STATUSES_SUCCESS, statuses });
//        logAPI("Saga.Portal.GetRoomStatuses", start, null);
//    }
//    catch (error) {
//        logAPI("Saga.Portal.GetRoomStatuses.Failure", start, null);
//        yield put({ type: types.GET_ROOM_STATUSES_FAILURE });
//    }
//}

export function* handleGetProviderJWT(payload) {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        yield put({ type: types.GET_PROVIDER_JWT_PENDING });
        const providerToken = yield call(
            portal.getProviderJWT, domain.t, payload.participantExternalId, payload.participantName, 
            domain.er === 'staff' ? 'Staff' : 'Provider', payload.roomId, payload.apiVersion
        );
        yield put({ type: types.GET_PROVIDER_JWT_SUCCESS, providerToken });
        if (payload.callback) {
            payload.callback(providerToken, null);
        }
        logAPI("Saga.Portal.GetProviderJWT", start, payload, payload.roomId);
    }
    catch (error) {
        if (payload.callback) {
            payload.callback(null, error);
        }
        logAPI("Saga.Portal.GetProviderJWT.Failure", start, payload, payload.roomId);
    }
}